export const CONTINENTS = {
  'africa': 'Afrique',
  'americaNord': 'Amérique du Nord',
  'americaSud': 'Amérique du Sud',
  'asia': 'Asie',
  'europe': 'Europe',
  'oceania': 'Océanie'
};
